import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=cddf94d8&scoped=true"
import script from "./detection.vue?vue&type=script&lang=js"
export * from "./detection.vue?vue&type=script&lang=js"
import style0 from "./detection.vue?vue&type=style&index=0&id=cddf94d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddf94d8",
  null
  
)

export default component.exports